import { createSlice } from '@reduxjs/toolkit'

export enum Categoties {
  Shares = 'Shares',
  Crypto = 'Crypto',
  Forex = 'Forex',
  Commodities = 'Commodities',
  Indices = 'Indices',
  Bonds = 'Bonds',
}

export type Discover = {
  mostTraded: { name: Categoties; percent: number; topTraded: { name: string; percent: number }[] }[]
}
const initialState: Discover = {
  mostTraded: [
    {
      name: Categoties.Shares,
      percent: 5,
      topTraded: [
        { name: 'TSLA', percent: 99 },
        { name: 'NVDA', percent: 35 },
        { name: 'MSTR', percent: 35 },
        { name: 'NFLX', percent: 10 },
        { name: 'PLTR', percent: 35 },
        { name: 'WLN', percent: 10 },
        { name: 'TLRY', percent: 35 },
        { name: 'COIN', percent: 10 },
      ],
    },
    {
      name: Categoties.Crypto,
      percent: 30,
      topTraded: [
        { name: 'BTC/USD', percent: 100 },
        { name: 'XRP/USD', percent: 80 },
        { name: 'ETH/USD', percent: 60 },
        { name: 'BABYDOGE/USD', percent: 10 },
        { name: 'SOL/USD', percent: 60 },
        { name: 'PEPE/USD', percent: 10 },
        { name: 'DOGE/USD', percent: 10 },
        { name: 'ZEC/USD', percent: 10 },
      ],
    },
    {
      name: Categoties.Forex,
      percent: 2,
      topTraded: [
        { name: 'EUR/USD', percent: 100 },
        { name: 'USD/JPY', percent: 50 },
        { name: 'GBP/USD', percent: 30 },
        { name: 'GBP/JPY', percent: 20 },
        { name: 'AUD/USD', percent: 30 },
        { name: 'USD/CHF', percent: 20 },
        { name: 'EUR/JPY', percent: 20 },
        { name: 'USD/MXN', percent: 20 },
      ],
    },
    {
      name: Categoties.Commodities,
      percent: 53,
      topTraded: [
        { name: 'Gold', percent: 100 },
        { name: 'Natural gas', percent: 10 },
        { name: 'Silver', percent: 10 },
        { name: 'Oil-Crude', percent: 10 },
        { name: 'Silver', percent: 10 },
        { name: 'Oil-Brent', percent: 10 },
        { name: 'Us-Cocoa', percent: 10 },
        { name: 'Copper', percent: 10 },
        { name: 'GCG2026', percent: 10 },
      ],
    },
    {
      name: Categoties.Indices,
      percent: 15,
      topTraded: [
        { name: 'US100', percent: 99 },
        { name: 'US30', percent: 24 },
        { name: 'DE40', percent: 24 },
        { name: 'US500', percent: 10 },
        { name: 'J225', percent: 24 },
        { name: 'HK500', percent: 10 },
        { name: 'NQZ2025', percent: 10 },
        { name: 'RTY', percent: 10 },
      ],
    },
    {
      name: Categoties.Bonds,
      percent: 0,
      topTraded: [
        { name: 'US', percent: 99 },
        { name: 'FLGTH2026', percent: 24 },
        { name: 'TY', percent: 24 },
        { name: 'FOATH2026', percent: 10 },
        { name: 'FGBXH2026', percent: 24 },
        { name: 'USH2026', percent: 10 },
        { name: 'FGBMH2026', percent: 24 },
        { name: 'FBMD2026', percent: 10 },
      ],
    },
  ],
}

const discoverSlice = createSlice({
  name: 'discover',
  initialState,
  reducers: {},
})

export default discoverSlice.reducer
